<template>
    <div class="header-container">
        <div class="header-content">
        <div class="header-left">
            <img class="aiqicha-logo" src="../assets/aiqicha_logo.png">
            <div class="line"></div>
            <img class="company-logo" src="../assets/company_logo.png">
        </div>
        <div class="header-right">
            <a class="link-console" href="https://console.bce.baidu.com" target="_blank"
            data-track-value="landHeaderConsole" data-track-name="管理控制台">管理控制台</a>
            <div class="login-container">
            <a class="link-login" @click="jumpLogin"
                data-track-value="landHeaderLogin" data-track-name="登录">登录</a>
            <div class="line"></div>
            <a class="link-register"
                href="https://login.bce.baidu.com/reg.html?tpl=bceplat&from=mkt" target="_blank"
                data-track-value="landHeaderRegister" data-track-name="免费注册">免费注册</a>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        jumpLogin() {
            let loginPath = 'https://login.bce.baidu.com/?redirect=';
            window.open(loginPath + location.href);
        }
    }
}
</script>

<style lang="less" scoped>
.header-container {
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    border-bottom: 1px solid #DBDBDB;
    .line {
        width: 1px;
        height: 13px;
        background-color: #DEDEDE;
    }
    .header-content {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
    }
    .header-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        float: left;
        height: 60px;
        width: 220px;
        .aiqicha-logo {
            width: 86px;
            height: 27px;
        }
        .line {
            margin-top: 2px;
        }
        .company-logo {
            width: 108px;
            height: 20px;
            margin-top: 3px;
        }
    }
    .header-right {
        float: right;
        height: 60px;
        display: flex;
        align-items: center;
        .link-console {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #666;
            margin-right: 50px;
            text-decoration: none;
        }
        .login-container {
            display: flex;
            align-items: center;
            .line {
                margin: 0 16px;
            }
            .link-login {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #666;
                cursor: pointer;
            }
            .link-register {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #2468F2;
                text-decoration: none;
            }
        }
    }
}
</style>
